/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_General_OptionsInputs */

const en_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Options`)
};

const fr_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options generales`)
};

const de_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Optionen`)
};

const it_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni generali`)
};

const ru_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общие параметры`)
};

const es_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones generales`)
};

const zh_cn2_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般选项`)
};

const ja_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般オプション`)
};

const hi_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आम विकल्प`)
};

const pt_pt2_subtitle_import_general_options = /** @type {(inputs: Subtitle_Import_General_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções gerais`)
};

/**
* | output |
* | --- |
* | "General Options" |
*
* @param {Subtitle_Import_General_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_general_options = /** @type {((inputs?: Subtitle_Import_General_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_General_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_general_options(inputs)
	if (locale === "de") return de_subtitle_import_general_options(inputs)
	if (locale === "it") return it_subtitle_import_general_options(inputs)
	if (locale === "ru") return ru_subtitle_import_general_options(inputs)
	if (locale === "es") return es_subtitle_import_general_options(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_general_options(inputs)
	if (locale === "ja") return ja_subtitle_import_general_options(inputs)
	if (locale === "hi") return hi_subtitle_import_general_options(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_general_options(inputs)
	return en_subtitle_import_general_options(inputs)
});